import React, { useEffect, useRef, useState } from 'react';

export const CookieBanner = () => {
  const [visible, setVisible] = useState(() => !localStorage.getItem('cookieConsent'));
  const barRef = useRef(null);

  // Reserve space at the bottom so the bar never hides page content
  useEffect(() => {
    if (!visible || !barRef.current) {
      document.body.style.paddingBottom = '';
      return;
    }
    const setPad = () => { document.body.style.paddingBottom = `${barRef.current.offsetHeight}px`; };
    setPad();
    const ro = new ResizeObserver(setPad);
    ro.observe(barRef.current);
    return () => { ro.disconnect(); document.body.style.paddingBottom = ''; };
  }, [visible]);

  const choose = (granted) => {
    if (window.updateConsent) window.updateConsent(granted);
    window.fbq && window.fbq('consent', granted ? 'grant' : 'revoke');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      ref={barRef}
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-50 bg-ink text-oat px-4 py-2.5 shadow-[0_-4px_16px_rgba(0,0,0,0.12)]"
    >
      <div className="max-w-[960px] mx-auto flex items-center gap-3">
        <p className="font-hanken text-xs sm:text-sm leading-snug flex-1">
          we use cookies to improve your experience & measure ad performance.
        </p>
        <button
          onClick={() => choose(false)}
          data-testid="cookie-decline-btn"
          className="font-hanken text-xs sm:text-sm text-oat/70 underline underline-offset-2 hover:text-oat transition-colors flex-shrink-0"
        >
          decline
        </button>
        <button
          onClick={() => choose(true)}
          data-testid="cookie-accept-btn"
          className="font-hanken font-bold text-xs sm:text-sm bg-lime text-ink-deep px-4 py-1.5 rounded-full hover:bg-lime/90 transition-colors flex-shrink-0"
        >
          accept
        </button>
      </div>
    </div>
  );
};
